module.exports = __webpack_public_path__ + "img/wenyuxia.f06389e4.jpg";